export default __webpack_public_path__ + "4c17f1a77f8cf00b858fa62ccc09d3b8.svg";